import { api } from "./api"

export const GET_NOTIFICATIONS = async ({ page, ...others }) => {
    const {data} = await api.get("/notifications/all", { params: { page, ...others }})
    return data || [];
}

export const GET_NOTIFICATIONS_QUANTITY = async () => {
    const {data} = await api.get("/notifications/quantity")
    return data || [];
}

export const READ_NOTIFICATIONS = async (items: {id: string; read: boolean;}[]) => {
    const {data} = await api.patch(`/notifications/read`, {items})
    return data;
}
